module.exports = __webpack_public_path__ + "img/overview-top-3.d04e1c58.png";